import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  scrollBox: {
    height: `calc(100vh - 64px)`,
    display: 'flex',
    padding: theme.spacing(5),
    flexDirection: 'column',
    overflowY: 'auto',
  },
}));

export default useStyles;
